/**
 * A driver's name, in the two halves every form now asks for.
 *
 * Booking.com takes `firstName` and `lastName` separately and refuses a
 * blank either side — that is what has been happening in production, and
 * the trip then reaches the passenger with no driver named at the partner.
 * The API requires both halves on every path that writes a driver; these
 * helpers are so the forms say the same thing before the round trip, in the
 * shape FormControlFeedback already renders.
 *
 * `full_name` is composed by the API, family name first, and is still what
 * every list and label shows. Nothing here posts it.
 */

const LABELS = {
  first_name: 'First name',
  last_name: 'Last name',
};

/** "  Kovács  " → "Kovács". */
export const tidyName = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();

/**
 * The display name the API will compose, so a form can match the row it
 * just created without waiting to be told its id.
 */
export const composeDriverName = (driver) => [
  tidyName(driver?.last_name),
  tidyName(driver?.first_name),
].filter(Boolean).join(' ');

/**
 * The missing halves, as `{ field, message }` — the same shape the API's
 * 400 comes back in, so the same <FormControlFeedback> shows either.
 */
export const driverNameErrors = (driver) => ['first_name', 'last_name']
  .filter((field) => !tidyName(driver?.[field]))
  .map((field) => ({ field, message: `${LABELS[field]} is a required field` }));

/** Whether both halves are filled in — for enabling a Save button. */
export const hasDriverName = (driver) => driverNameErrors(driver).length === 0;
